import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
  calibrationList: any;
  calibrationNewList:any
  tabGloabalValue:any
  loading: boolean;
  IsCalibratioChange: boolean;
}

const initialState: InitialState = {
  calibrationList: [],
  calibrationNewList: [],
  tabGloabalValue:"",
  loading: false,
  IsCalibratioChange: false,
};

const calibrationSlice = createSlice({
  name: "tenant",
  initialState,
  reducers: {
    calibrationList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      calibrationList: action.payload,
    }),
    calibrationNewList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      calibrationNewList: action.payload,
    }),
    setLoader: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      loading: action.payload,
    }),
    setTabValueGlobal: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      tabGloabalValue: action.payload,
      IsCalibratioChange: false,
    }),
    setChangeCalibratioValue: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      IsCalibratioChange: action.payload,
    }),
  },
});

export const { calibrationList,calibrationNewList, setLoader, setTabValueGlobal,setChangeCalibratioValue } = calibrationSlice.actions;

export default calibrationSlice.reducer;
